import AddFavoriteProduct from "../classes/AddFavoriteProduct";

(() => {
    Array.from(document.querySelectorAll('.product-page__info-payment-favorites')).forEach(btn => {
        new AddFavoriteProduct(btn);
    });
})();
